<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'
import Pagenation from './Pagenation'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about-2024 history">
    <Head title="A&F40年の歴史を、創業者・赤津孝夫が振り返る。" />
    <div class="pb-[50px]">
      <div class="header-img-block">
				<!-- <h2 class="page-title">
					History
					<small>創業者・会長 赤津孝夫</small>
				</h2> -->
			</div>

      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[840px] ">

				<h2 class="page-title">
					History
					<small>創業者・会長 赤津孝夫</small>
				</h2>
							
				<p>　1965年、東京・新宿......。東京オリンピックの翌年、西口にあった淀橋浄水場が閉鎖された。その広大な跡地にやがて生まれるのが高層ビルの林立する副都心だ。まだ新宿が古くからの風景を残しながら、新しい都市へ向かって舵を切り始めたとき、赤津孝夫はこの町と本格的に親しみ始めた。</p>
				<p>　「生まれ育ったのは長野県塩尻市です。親父もこの町で生まれたのですが、大志を抱いて戦前、満州へ開拓に渡りました。ところが敗戦で、命からがら引き揚げ、故郷に戻って製菓業を起業したんです。野心家であるとともに、狩猟や釣りを愛し、山菜やキノコを採りに山を歩くのが好きな冒険心あふれる趣味人でしたね。幼い頃は父とよく山へ行き、高校生になると、北アルプスの山々を登るようになりました。あの頃憧れたのは、フランスの登山家にして名ガイド、ガストン・レビュフォア(1921~ 85)。人類史上初めて8,000m峰に立った男ですよ。それで、ピッケルはシャルレがいいなぁ、ザックはフランスのミレーだなぁと思っていましたね。そうしているうちに、親父が当時、ミノルタのSR-1という一眼レフを持っていて、親父の目を盗んでそれを持ち出して山で写真を撮るようになったんです。おもしろくて仕方なかった。熱中しました。それで、日本大学芸術学部写真学科に進学することにしたんです」</p>

				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_01.jpg" alt="かつての信州の社屋は現在、A&Fの倉庫のひとつにもとなっている。">
					<p class="caption">
						かつての信州の社屋は現在、A&amp;Fの倉庫のひとつにもなっている。
					</p>
				</div>

				<p>　「キャンパスは練馬区江古田でしたから、遊びに出るのは池袋の繁華街が多かったんですけど、新宿のほうに足が伸びちゃうんですね。新宿中央線が出発点であり到着点ですよ。東北出身の人にとっての上野駅が、信州出身のものにとっては新宿駅なんでしょうね。実際、新宿には信州の人が少なくありませんでした。当時、若者向けのファッション誌やライフスタイル誌が出始めていて、将来は、そうした雑誌、あるいは広告といった商業写真の世界で仕事をしていきたいと夢を描いていました。学園紛争の時代でした。大学は封鎖され、塩尻に帰っていたこともありました。どうでしょう4年のうち2年ぐらいしか行ってないんじゃないかな。それでも卒業して、雑誌や広告で活躍していたカメラマンの吉田大朋さんのアシスタントになりました。そうやって過ごしているうちに仲間に誘われてダイビングを始めたんです」</p>
				<p> 　道具を揃えたり情報を得たりするのは、数少なかった輸入専門店だった。赤津は、新宿・歌舞伎町の東京銃砲火薬店によく出入りするようになった。1階で銃をはじめとした狩猟具を扱い、2階でダイビング用品を扱っていた。とりわけ古くから扱う銃ではアメリカの事情に通じ、レアな道具、その世界の情報を求めて同好の士が集まり、常連客の中には作家の大藪春彦(1935~96)もいた。大藪は、アメリカのハードボイルド文学に影響を受け、孤独のヒーローを描いて当時すでに人気作家だった。 作中の主人公は、権力に抗し、荒野にあっては自力で命をつなぐ。独自の審美眼で選び抜いた道具たちを相棒にし、作中では銃、車、オートバイ、ナイフ、腕時計、喫煙具、衣類などが実名入りで詳細に描かれた。大藪は、海外の車、工具、狩猟具、装身具の紹介者でもあったのだ。</p>
				<p class="block-end">　「1972年ごろ、店に出入りするようになると、取り寄せた道具の広告を作るから撮影してくれ、と頼まれるようにもなっていきました。アメリカから雑誌やカタログを取り寄せて、そこで目星を付けた道具を輸入するわけです。自分たちでタイプライターを叩いて手紙を作り、あるいはテレックスを送って、まだ手間が掛かった海外送金で支払いをすると、やがて段ボールが届きます。わくわくしながらそれを開けて商品を出し、撮影しました。東京銃砲火薬店は藤田さんのファミリー・カンパニーでした。親父さんは当時すでに50代で、知っていることは全部教えていただきました。また、娘さんと息子さんは僕とほぼ同世代で、貿易業務は娘さんと貿易の担当者がやっていました。それで若い連中で話し合って、道具を探して輸入するようになっていったんです。</p>
				<p> 　‘70年代の初めのアメリカでは、若い世代にバックパッキングが支持され始めていました。西海岸を中心に。ケルティは’50年代からザックを作っていましたが、アルミ製のフレームを背負子のように加工したザックが人気になっていったんです。シェラ・デザインズなどの新興メーカーも立ち上がったりして。そうした、まだガレージ・メーカーだった彼らの製品をひとつ、またひとつと輸入していったんです。当時はヒッピーの時代です。コロンビアのクラッシャー・ハットはバックパッカーのシンボルでした。当時、バックパッカーといえば、このハット、シェラカップ、バンダナが三種神器といわれていましたね。それも輸入しましたよ。</p>
				<p> 　一方、アメリカの東海岸には狩猟、フライ・フィッシング、ルアー・フィッシングの伝統が、それこそイギリスから移民が始まった時代から連綿と続いていました。そんな文化を支えていたのはメイン州が拠点のL.L.ビーンです。東がLL.ビーンなら、西はエディーバウアーで、双璧でしたね。東京銃砲火薬店はそちらのほうが本領で、店ではアメリカの古くからの狩猟と釣りの文化と新しいバックパッキングの文化が同居するようになっていきました。僕はフリーカメラマンを続けつつ、’73年に会社を立ち上げました。いつしか店で扱う商品は1,000アイテムを超えていきました。東京銃砲火薬店は古くからの仕事に専念し、新しくバックパッキングに関連した商品を中心に扱う別会社を立ち上げようとなったんです。そして、1977年に会社設立になりました。社名は、赤津のAと藤田のFを合わせてA&amp;Fとしたんです」</p>

				<h3>創業期<small>クラフトマンシップに引き寄せられて </small></h3> 
				<p>　「会社創設当初から、輸入品の卸売、通販、そして店舗販売という3本柱で営業していきたいという思いはありました。いいものを輸入できたとしても、扱ってくれる店舗がなければ売れません。ですから自分たちで店舗を持ちたくなるわけですが、立ち上げたばかりの会社ではそれは無理でした。それで、まずは卸売に専念していったんです。幸い、モノのよさを理解してくれ扱ってくださるお店は徐々に増えていきましたね。もちろん、営業して店舗を探し、デパートの催事場などで仲間とイベントを開くこともやっていきました。新宿の職安通りの近くに事務所と倉庫を借りてスタートさせたんですが、雑誌に広告を載せたりしますと店舗があるのだと思って訪ねてくる人が少なくありませんでした。それも悪いので、創業の翌年にはカタログを作って通販に力を入れていったんです。カタログは初めからしっかり作り、後には当社の看板になっていきます。また、大久保通りに面した2軒目の事務所には、小さいけれどしっかりした商品展示コーナーを作ったんです。取り扱うアイテムはどんどん増えていきましたが、スタッフで話し合って、まずモノ自体が深い世界観を持ち、そこに共感できて自分たちでも使ってみたいと思えることが重要でした。僕自身がまず深く入り込んでいったのはナイフだったんです」</p>

				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_02.jpg" alt="創業時に事務所を構えた界隈。花園神社に近い新宿6丁目で、現在の本社が入る高層ビルからも近い。">
					<p class="caption">
					創業時に事務所を構えた界隈。花園神社に近い新宿6丁目で、現在の本社が入る高層ビルからも近い。
					</p>
				</div>

				<p>　ナイフは人類最初の道具だ。その証拠である石器の研究から近年、新しい仮説が導き出された。それまでは、生物としての進化を果たしたから道具が精巧になったと考えられていたが、どうやらそれは逆だというのである。同じ地層から使用痕のまったくない美しい石器が出た。人類学者はそれを見て、人類はまず精巧な道具を作り、その製作者への畏敬、作られたモノに神聖な性質を見ていく文化を生み出し、その果てに進化を遂げていったと考えたのだ。</p>
				<p>　「じつは、創業前の1973年に僕は、藤田家の息子さんとアメリカに初めて行ったんです。バックパックを背負って、モーテルを泊まり歩きながら各地の展示会を訪ねて回りました。あの頃、僕らの興味ある商品を扱う最大の展示会は、ナショナル・スポーティンググッズ・アソシエーション(NSA)が主催の展示会だったんです。アウトドア・リテイラー・ショー(通称 ORショー)と銘打つ展示会が開かれるのは‘82年のことでしたから、それ以前の商品のジャンルとしても遊びのカテゴリーとしてもアウトドアという言葉が浸透していなかった頃は、バックパッキング関連の道具も狩猟や釣り、キャンプの道具もスポーツで括られていたんです。それでNSAの展示会に行ったんです。大きなコンベンション・センターに錚々たるメーカーがブースを設けて並んでいました。何日かかけて見て回って、これはと思うメーカーと商談していったわけですが、その展示会の後、ミズーリ州のカンザスシティでカスタムナイフ・ギルド・ショーへも行ったんです」</p>
				<p>　「僕は、高校時代の山登りでは安い登山ナイフをいつも持っていました。カメラもナイフに共通する金属製のメカニカルな造形から関心が高まったのかもしれません。カスタムナイフを知ったのは、東京銃砲火薬店でとっていたアメリカの銃関係の雑誌でした。大量生産の国だと思っていたら、その一方にカスタム、手作りの文化が重厚にあった。それを知ったのは衝撃でしたね。ナイフには、まず鉄を赤めて鍛えて作る伝統的なフォージング(鍛造)法があります。カスタムナイフは、鉄鋼メーカーから鋼の板材を仕入れ、削り上げるストック&リムーバル製法です。大きな機械に頼らず手作業で、お客さんからの注文に従って削り上げていきます。アメリカには、古くからカスタムナイフ・メーカーはいたのですが、ギルドを創設して自分たちの地位を高めようとしたのがR・W・ラブレス(1929~2010)でした。カンザスシティーでのショーの翌年、僕はロサンゼルスの郊外にあった工房に彼を初めて訪ねたんです」</p>
				
				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_03.jpg" alt="カスタムナイフメーカー「ウッズ」が考えた機構をつかった数少ないフォールディングナイフ。取り扱い が図解された説明書もウッズ氏が描いたものである。">
					<p class="caption">
					カスタムナイフメーカー「ウッズ」が考えた機構をつかった数少ないフォールディングナイフ。取り扱いが図解された説明書もウッズ氏が描いたものである。
					</p>
				</div>
				<p>
					　それ以来、長い付き合いになりましたが、彼には、これが職人魂、クラフトマンシップだという思いをさせられましたね。リスペクトの気持ちは薄れたことはありません。モノを見極めるのは3段階が必要だといつもいっていましたよ。まず、見て興味を持たれないとダメだ、と。その次に、はじめて触った瞬間に「いい!」と感じてもらえるか。持ち心地がいいとか、手に合っているかどうかですね。そして最後は使ってどうか。彼のナイフはすごく手にフィットするんです。そのうえ、ハンドルとブレードの間に赤いライナーがわずかに入っていまして、これは機能ではないんですが、女性が口紅を入れるだろっていうんですよ。彼のそういった哲学は、すべての道具にいえることだと思います。ナイフではもうひとつ、BUCKに出会ったのは大きなことでしたね。こちらは量産メーカーですが、長年『ライフタイム・ギャランティー』、生涯保証という考え方を貫き、ユーザーがナイフを使い、切れ味が落ちたらブレードを研ぐ。そうやって使い込んでも、壊れたら修理をしてくれるんです。道具を提供するからには、そのくらい責任を持っていかなくてはいけないと思いました。BUCKのこの思想が、当社に修理部門を備えていく布石になりました」
				</p>

				<h3>
				発展期 <small>芦沢一洋さんとの出会い </small>
				</h3>

				<p>　A&amp;Fの創業と前後して、’70年代中頃から’80年代の前半に日本にもアウトドア雑誌が相次いで創刊された。自然に親しみ、都市生活にも自然趣味を取り入れていくライフスタイルが各地で芽生え、愛好者の存在を察知しての雑誌創刊だ。A&amp;Fに徐々に蓄えられていった道具とその背景にある文化に関する情報は、草創期のアウトドア雑誌を支え、そこで活躍するクリエーターたちとA&amp;Fとの交流も深まっていった。そんなクリエーターのひとりに芦沢一洋(1938~96)がいた。フリーランスのグラフィック・デザイナーとして数々の雑誌に参画する一方、コリン・フレッチャーの『遊歩大全』を翻訳し、自身でも『バックパッキング入門』を著した。また、フライフィッシングの普及にも大きな貢献をした。</p>

				<div class="imgfloat">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_04.jpg" alt="森林書房より発行されたのは1978年、原書の初版からちょうど10年後だった。同書は現 在、ヤマケイ文庫にラインナップされ発行が続いている。">
					<p class="caption">
					森林書房より発行されたのは1978年、原書の初版からちょうど10年後だった。同書は現在、ヤマケイ文庫にラインナップされ発行が続いている。
					</p>
				</div>

				<p>　「創業のときから、洋書の販売もしたんです。僕自身、本というメディアに教えられたことが多かったですし、道具の背景を知ることができるのも本です。本と道具というふたつのメディアは伴走する関係にあると思ってきましたね。営業を続けていくなかで、登山、釣り、カヌーなど、ジャンルにこだわらずオールラウンドにアウトドア・カルチャーを捉えていこうという思いはありました。それでも、核は何かといったらバックパッキングなんです。バックパックに自給道具を詰めて歩いて旅するスタイルですが、何を詰めていくかは人それぞれでしょう。衣類と同じで、気に入らないモノを持つと気持ちも高まらないのはもっともなことで、背中に背負えるだけの限られたモノとなればなおのこと、気に入ったモノだけで満たしたくなりますよ。</p>

			
				<p>
				　それから、これは芦沢さんの書かれていることですが、バックパッキングはクワイエット・スポーツ=静かなるスポーツだということも大切なことだと思います。根底にあるのは文明批判です。自然に親しんで自然を見直し、学び、大切にするマインドを育てようという考えです。</p>
				<p>　使い捨てではなく、修理しながら長い間使っていく道具文化も、バックパッキングというカルチャーにはあると思ってきました。ですから、出会っていくのもそうした誠実な道具文化を継承するメーカーが多くなっていきました。もちろん、メーカーの事業形態はさまざまです。アウトドア関係はベンチャー・カンパニーが多いのがひとつの特徴ですが、創業者がいまだにミシンを踏み続けているようなところもあれば、ガレージ・ブランドとして始まったのだけれども、成長して立派な企業になったところもあります。一方で、創業者の家系で代々経営してファミリー・ビジネスを続けてきた企業もあって、ダッチオーヴンのLODGEなどはその典型ですね。19世紀の創業で、開拓時代の荒野でどうやって暮らそうかというなかで生まれた、鋳鉄のずっしりと重たい調理器具をずっと作り続けてきました。バックパックの中に詰め込めるような調理器具ではありませんが、文明が高度化していく流れにあって昔ながらの製品からは、文明の再検討の精神を重ね合わせることができるんだと思います。ですから、バックパッキングの精神を持ったまま定着型のキャンプをしてみようとか、家庭でも実践してみようとか思う人が現われ、支持されていったのだと思います」
				</p>
				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_05.jpg" alt=" 創業家を訪ねた際に赤津が贈られた約100年前のスキレット。使い込まれたためバリがほとんど取れてツ ルツルである。">
					<p class="caption">
					 創業家を訪ねた際に赤津が贈られた約100年前のスキレット。使い込まれたためバリがほとんど取れてツルツルである。
					</p>
				</div>

				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_06.jpg" alt="‘60年代の西海岸サウンドを代表するビーチボーイズはペンドルトンのシャツがステージ衣装だった。 『SUFER GIRL』は’63年のリリース。このときのシャツは2002年に復刻販売された。">
					<p class="caption">
					‘60年代の西海岸サウンドを代表するビーチボーイズはペンドルトンのシャツがステージ衣装だった。 『SURFER GIRL』は’63年のリリース。このときのシャツは2002年に復刻販売された。
					</p>
				</div>
				<p>
				　「こうした誠実なモノ作りをするメーカーとは、こちらも誠実に付き合っていかなくてはいけません。それで彼らが成長していくのに伴走できるのは、われわれのビジネスの醍醐味でもありますが、やはり、厳しい判断が求められるとことのほうが多いです。メーカーのスタッフ、製作者とは趣味が共通しているわけですから、フライフィッシングをやろうとか、いっしょに旅に出ようといった誘いを受けたり、こちらから誘ったりもしてきました。キャンプの夜の雑談から新しいビジネスのアイディアが生まれることもあるのですが、いざ実行するとなればお互いに冷徹な判断も必要になってきます。やはり日本で販売する以上、日本の自然環境や風土に合い、そこで楽しむユーザー身体、ライフスタイルにフィットする商品でなくてはいけません。そこで、日本市場に合う商品をこちらから依頼することもありましたね」
				</p>

				<h3>
					転機と今後
					<small>オーガニック・グロウスを心がけて</small>
				</h3>
				<p>
					　「いっしょに成長してきたということですと、Gregoryとの付き合いは得がたい経験でしたね。創業者のウェイン・グレゴリー(1948~)は、当初から世界一のバックパックを作るのだと口にして、ウエストベルトへの自然な荷重分散をするためのアクティブ・サスペンション・システム、“背負うのではなく着なさい”をキャッチフレーズに衣類のように身体に合ったサイズを設けました。アウトドアの道具が、粗野な感じをたたえたモノから精密な設計を行ない、高性能な素材を使用していく先駆けでしたね。そうやってフィッティングを追求した商品は、大型パックだと8万円になりましたし、デイパックなどは他のブランドが数千円の時代に2万円でしたから、扱い始めた1985年の頃は売れるのかどうか半信半疑だったんです。しかし、次第に支持されていきました。Barbourのときなども、コットンに油脂を染み込ませたオイルスキンのレインウエアですから、決して売れないともいわれていたんですが、街着としても人気になっていきました。Gregoryもタウン・ユースとして渋カジ、アメカジと評された若者たちの人気を呼んでいったんです。やはり日本人はモノの細部まで追求する精神があるな、と感心したものです」
				</p>
                <div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_10.jpg" alt="">
					<p class="caption">
					 当時のA&Fスタッフとウェイン・グレゴリー。富士山にて。
					</p>
				</div>
				<p>
					　僕としては、バックパッキングの精神を忘れてほしくないなと思っています。自然に親しみ、自然を愛する精神は地球規模で環境危機が叫ばれる現代ではいっそう重要さを増しています。環境問題の解決に何らかのコミットしていくのは、アウトドアの業界全体で当たり前になってきていますよね。でも、他の先進国に比べると日本は進んでいない。それを考えても、道具とともに背景にある文化を伝えていく本というメディアが大切だと思うんです。
				</p>	
				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_11.jpg" alt="イラストレーター ジャック・アンルー">
					<p class="caption">
					 イラストレーター ジャック・アンルー。
					</p>
				</div>
				<p>	
					　当社では、創業間もない時期からカタログに力を入れてきました。僕自身が若い頃、商業写真家を目指して雑誌作りに関心が向いていたことも影響しています。フライフィッシングを愛し、ウィルダネスにあるさまざまなシーンを審美的な細密画に描くジャック・アンルー(1935~2016)を表紙に起用したのも、本に対する思いの強さの現われでしょう。カタログは当初、取り扱う商品の販売店が近隣にない方々に向けた通販用でしたが、オンラインショップを開設してからは、掲載商品を主力ブランドの主力商品に絞り込んで、寄稿者を募って雑誌風の作りに変えていったんです。そして、その延長ともいえますが、2016年から自社での出版も始めました」
				</p>
				<div class="imgwrap">
					<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_07.jpg" alt=" 赤津にとって本は道具と同じ価値。本から道具と文化を知り、道具から学んだ技術を本に書いて文化を発信してきた。">
					<p class="caption">
					 赤津にとって本は道具と同じ価値。本から道具と文化を知り、道具から学んだ技術を本に書いて文化を発信してきた。
					</p>
				</div>

			

 
 					<p>　「以来、年に5、6冊のペースで出していますが、そのなかの1冊に『アウトドア・サバイバル技法』があります。著者のラリー・D・オルセンは、少ない道具で自然のなかで生き抜く術をマウンテンマンやネイティブ・アメリカンから学び、その技術を学習プログラムにしていきました。その内容を書いたのが、この本です。初版は1967年ですが、出て間もない頃に手にして、いい本だなと思ったんですね。すると、その後も版を重ねて読み継がれていっていました。それで、日本にもアウトドア体験が学校のプログラムに入ってくるような時代が来るに違いないと、翻訳出版することを決めました。</p>
					<p>　焚火をする、ナイフで木を削ってみるという体験から自然の尊さに気付くとしたら、1968年に出た『ホールアース・カタログ』の時代に宇宙から撮った写真から地球の美しさに気付いたのと同じような意識革命です。今後は、アウトドア体験の大切さがよりいっそう高まっていくに違いありません」</p>

					<div class="imgflex">
						<p class="caption ">
						奇しくも『遊歩大全』の原書と同じ1968年に刊行された『ホールアース・カタログ』も赤津孝夫のコレクションにあった。ナイフのような原初からある道具で暮らしていく先に、人間と地球の健全な関係があるというメッセージが込められた書である。
						</p>
						<img src="https://img.aandf.co.jp/aandfcojp/img/corporate/aboutImg_08.jpg" alt="奇しくも『遊歩大全』の原書と同じ1968年に刊行された『ホールアース・カタログ』も赤津孝夫のコレクションにあった。ナイフのような原初からある道具で暮らしていく先に、人間と地球の健全な関係があるというメッセージが込められた書である。"
						class=""
						>
					</div>
                    <p>（文＝藍野裕之）</p>
					<p>（写真＝岡野朋之）</p>
					<div class="clearfix"></div>

      </div>
    </div>
  </div>
</template>
